module.exports = __webpack_public_path__ + "img/KOBO.28540d13.svg";